import styled from 'styled-components';

export const BlockWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ count }) => (count >= 3 ? '1fr 1fr' : 'repeat(auto-fit, minmax(140px, 1fr))')};
  width: 100%;
  margin: 2rem 0;
  gap: 1px;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
  }
`;

export const ButtonMeta = styled.div`
  text-align: center;
  font-size: 12px;
  color: #777;
  margin-top: 0.25rem;
  word-break: break-word;

  span {
    display: block;
  }
`;

export const BlockButton = styled.button`
  height: 75px;
  letter-spacing: 0.5px;
  line-height: 50px;
  padding: 0 35px;
  font-size: 15px;
  background-color: black;
  color: white;
  text-transform: uppercase;
  font-family: 'Open Sans Condensed';
  font-weight: bolder;
  border: 1px solid grey;
  border-radius: 0px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${({ isLastOdd }) =>
    isLastOdd &&
    `
    grid-column: span 2;
  `}

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid #f4f4f4;
  }

  @media (min-width: 768px) {
    height: 100px;
    font-size: 35px;
  }
`;

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 2rem 1rem;
`;